(() => {
  const CURRENT_PATH_KEY = 'omnee:current-internal-path';
  const PREVIOUS_PATH_KEY = 'omnee:last-internal-path';
  const BLOCKED_STORE_PREFIXES = ['/cart', '/collections/all', '/account', '/checkout'];
  const isDesignMode = Boolean(window.Shopify && window.Shopify.designMode);
  const is404Template = document.body.classList.contains('page-type-404') || document.body.classList.contains('template-name-404');

  const normalizePath = (value) => {
    if (!value) return '';

    try {
      const url = new URL(value, window.location.origin);
      if (url.origin !== window.location.origin) return '';
      return `${url.pathname}${url.search}${url.hash}`;
    } catch (error) {
      return '';
    }
  };

  const isBlockedPath = (value, blockedPrefix = '') => {
    const normalized = normalizePath(value);
    if (!normalized) return true;

    if (BLOCKED_STORE_PREFIXES.some((prefix) => normalized === prefix || normalized.startsWith(`${prefix}/`))) {
      return true;
    }

    if (!blockedPrefix) return false;
    return normalized === blockedPrefix || normalized.startsWith(`${blockedPrefix}/`);
  };

  const currentPath = `${window.location.pathname}${window.location.search}${window.location.hash}`;

  try {
    if (!isDesignMode && is404Template) {
      const storedCurrentPath = normalizePath(window.sessionStorage.getItem(CURRENT_PATH_KEY));
      const storedPreviousPath = normalizePath(window.sessionStorage.getItem(PREVIOUS_PATH_KEY));

      if (storedCurrentPath === currentPath) {
        window.sessionStorage.removeItem(CURRENT_PATH_KEY);
      }

      if (storedPreviousPath === currentPath) {
        window.sessionStorage.removeItem(PREVIOUS_PATH_KEY);
      }
    } else if (!isDesignMode && !isBlockedPath(currentPath)) {
      const previousCurrentPath = normalizePath(window.sessionStorage.getItem(CURRENT_PATH_KEY));

      if (previousCurrentPath && previousCurrentPath !== currentPath && !isBlockedPath(previousCurrentPath)) {
        window.sessionStorage.setItem(PREVIOUS_PATH_KEY, previousCurrentPath);
      }

      window.sessionStorage.setItem(CURRENT_PATH_KEY, currentPath);
    }
  } catch (error) {
    // Ignore storage failures and keep fallback behavior intact.
  }

  document.addEventListener('click', (event) => {
    const backButton = event.target.closest('.omnee-back-button');
    if (!backButton) return;

    if (isDesignMode) {
      return;
    }

    const blockedPrefix = backButton.dataset.blockedReferrerPath || '';
    const shouldForceFallback = backButton.dataset.forceFallback === 'true';
    const fallbackPath = normalizePath(backButton.getAttribute('href'));
    const storedPath = (() => {
      try {
        return normalizePath(window.sessionStorage.getItem(PREVIOUS_PATH_KEY));
      } catch (error) {
        return '';
      }
    })();
    const referrerPath = normalizePath(document.referrer);

    const canUsePath = (value) =>
      value &&
      value !== currentPath &&
      value !== fallbackPath &&
      !isBlockedPath(value, blockedPrefix);

    if (shouldForceFallback) {
      event.preventDefault();
      window.location.assign(fallbackPath || '/');
      return;
    }

    if (canUsePath(storedPath)) {
      event.preventDefault();
      window.location.assign(storedPath);
      return;
    }

    if (canUsePath(referrerPath)) {
      event.preventDefault();
      window.location.assign(referrerPath);
    }
  });
})();
